import React from "react";
import { ArrowRight, BadgePercent } from "lucide-react";
import { Button } from "./ui/button";

export default function CTABand({ onEnquire }) {
  return (
    <section className="py-14 lg:py-16 bg-gradient-to-r from-orange-500 to-orange-600 text-white relative overflow-hidden">
      <div className="absolute -top-20 -right-20 w-80 h-80 rounded-full bg-white/10 blur-2xl" />
      <div className="absolute -bottom-20 -left-20 w-80 h-80 rounded-full bg-white/10 blur-2xl" />
      <div className="relative max-w-7xl mx-auto px-4 lg:px-8 flex flex-col lg:flex-row items-center justify-between gap-6">
        <div className="flex items-start gap-4 max-w-2xl">
          <div className="hidden md:flex w-14 h-14 rounded-full bg-white/15 backdrop-blur items-center justify-center flex-shrink-0">
            <BadgePercent className="w-7 h-7" />
          </div>
          <div>
            <h3 className="text-2xl md:text-3xl font-extrabold leading-tight">
              Claim up to &#8377;78,000 subsidy on your rooftop solar.
            </h3>
            <p className="text-orange-50 mt-1">
              Zero-paperwork hassle. Our team files everything for you.
            </p>
          </div>
        </div>
        <Button
          onClick={onEnquire}
          className="bg-white text-orange-600 hover:bg-slate-100 h-12 px-7 rounded-md font-bold shadow-lg"
        >
          Book Free Survey <ArrowRight className="w-4 h-4 ml-1" />
        </Button>
      </div>
    </section>
  );
}
